module.exports = __webpack_public_path__ + "media/images/news/wx-000ecdde1596ce864d7986210af8c893.png";